import types from "./types";
import service from "./service";

const getMasterBudget = () => {
    return (dispatch, getState) => {
        dispatch({ type: types.GET_MASTER_BUDGET });
        const state = getState()
        service
            .getMasterBudget(state.master_budget.pagination.actualPage, state.master_budget.filters)
            .then(result => {
                dispatch(getAllSuccess({list: result.list, fields: result.fields}));
                dispatch(updatePagination(result.pagination));
            })
            .catch(err => dispatch(getAllFail(err)));
    };
};

const changePage = page => {
    return dispatch => {
        dispatch(changeVoaPage({ page: page }));
        dispatch(getMasterBudget());
    };
};
const updateFilter = filters => {
    return dispatch => {
        dispatch(changeFilters(filters));
        dispatch(changeVoaPage({ page: 1 }));
        dispatch(getMasterBudget());
    };
};

const getChoices = filters => {
    return dispatch => {
        dispatch({ type: types.GET_CHOICES });
        return service.getChoices(filters)
            .then(result => {
                dispatch({ payload: result.data, type: types.GET_CHOICES_SUCCESS});
                return result.data;
            })
            .catch(error => {
                const data = error.response;
                dispatch({ payload: data, type: types.GET_CHOICES_FAIL});
                return data;
            });
    };
};


const changeFilters = payload => ({
    type: types.FILTER_LIST,
    payload
});

const changeVoaPage = payload => ({
    type: types.CHANGE_PAGE,
    payload
});

const getAllSuccess = payload => ({
    type: types.GET_MASTER_BUDGET_SUCCESS,
    payload
});
const getAllFail = error => ({
    type: types.GET_MASTER_BUDGET_FAIL,
    payload: error
});

const updatePagination = payload => ({
    type: types.UPDATE_PAGINATION,
    payload
});

export default {
    getMasterBudget,
    changePage,
    updateFilter,
    getChoices,
};
